<template>
  <v-layout>
    <v-flex>

    <!-- Filtri -->
     <v-flex xs12 d-flex class="accent pa-1 elevation-1 white--text">
        <v-flex xs12 sm6 md3>
          <agricoltori-select
            :label="$t('label.cliente')"
            v-model="filters.agricoltore"
            class="input--dense"
            solo-inverted flat dark clearable/>
        </v-flex>

        <v-flex xs12 sm6 md3>
          <date-picker
            :prefix="$t('label.da') + ':'"
            v-model="filters.from"
            :max="filters.to"
            :locale="$i18n.locale"
            class="input--dense date-input"
            solo-inverted flat dark clearable/>
        </v-flex>

        <v-flex xs12 sm6 md3>
          <date-picker
            :prefix="$t('label.a') + ':'"
            v-model="filters.to"
            :min="filters.from"
            :locale="$i18n.locale"
            class="input--dense date-input"
            solo-inverted flat dark clearable/>
        </v-flex>

        <v-flex d-flex xs12 md3>
          <v-btn center dark depressed color="rgba(255,255,255,0.16)" class="ma-0 height-36" @click="clearFilters()">
            {{$t('prenotazioni.azioni.rimuovi_filtri') }}
          </v-btn>
        </v-flex>

      </v-flex> 

      <!-- Tabella reports -->
      <data-table ref="reportTable"
                  :headers="[
                  {text: $t('label.numero_attestato'), value: 'numero', width: 30},
                  {text: $t('label.data_scadenza'), value: 'validita_attestato', width: 15},
                  {text: $t('label.cliente'), value: 'id_agricoltore', width: 35},
                  {text: $t('label.tecnico'), value: 'id_tecnico', width: 20}]"
                  :items="reports" :loading="loading"
                  :rows-per-page="rowsPerPage" :total-items="totalItems"
                  @page="onPageChanged"
                  @click:item="showReportDialog">

        <template slot="items" slot-scope="{ item }">
          <td>
            <v-tooltip bottom>
              <v-icon slot="activator" :color="item.compilato ? 'success' : 'warning'">{{ item.compilato ? 'check_circle' : 'error' }}</v-icon>
              <span>{{ item.compilato ? $t('reports.messaggi.compilato') : $t('reports.messaggi.non_compilato') }}</span>
            </v-tooltip>
            <span class="ml-2" style="vertical-align: text-bottom">{{ item.numero }}</span>
          </td>
          <td>{{ item.dettagli.validita_attestato }}</td>
          <td>{{ item.id_agricoltore && getRagioneSocialeById(item.id_agricoltore) }}</td>
          <td colspan="2">{{ item.id_tecnico && getNomeCognomeById(item.id_tecnico) }}</td>
        </template>

      </data-table>

      <report-dialog ref="reportDialog" v-model="show"/>
      <report-documentation-dialog ref="reportDocumentationDialog"/>

    </v-flex>
  </v-layout>
</template>

<script>
import { AgricoltoriSelect, TecniciSelect, DatePicker } from '@/components/inputs'
import DataTable from '@/components/base/DataTable'
import ReportDialog from '@/components/ReportDialog'
import ReportDocumentationDialog from '@/components/ReportDocumentationDialog'

export default {
    name: 'Reports',
    components: { AgricoltoriSelect, TecniciSelect, DatePicker, DataTable, ReportDialog, ReportDocumentationDialog },
    data: () => ({
        loading: false,
        reports: [],
        rowsPerPage: 11,
        totalItems: 0,
        filters: {
            agricoltore: null,
            from: null,
            to: null
        },
        show:false,
        lastPage: 1
    }),
    watch: {
        filters: {
            handler () {
                this.$refs.reportTable.resetPage()
                this.reports = [];
                this.fetchData(1)
            },
            deep: true
        },
        show (newValue, old) {
            if(!newValue){
                // Closing
                this.reports = [];
                this.fetchData(this.lastPage);
            }
        }
    },
    mounted () {
        //  Per evitare errori prima carico i dati di agricoltori e tecnici e poi carico i report
        this.loading = true
        Promise.all([
            this.$store.dispatch('loadAgricoltori'),
            this.$store.dispatch('loadTecnici')
        ]).then(() => {
            this.fetchData(1)
        }).catch(e => {
            this.$snackbar.showServerError(e)
            this.loading = false
        })
    },
    methods: {
        getRagioneSocialeById (id) {
            let agricoltore = this.$store.getters.getAgricoltoreById(id)
            return agricoltore ? agricoltore.ragione_sociale : '-'
        },
        getNomeCognomeById (id) {
            let tecnico = this.$store.getters.getTecnicoById(id)
            return tecnico ? tecnico.nome_cognome : '-'
        },
        showReportDialog (report) {
            report.dettagli = JSON.stringify(report.dettagli);
            this.$refs.reportDialog.show(report, true)
        },
        clearFilters () {
            for (let key in this.filters) {
                if (this.filters.hasOwnProperty(key)) {
                    this.filters[key] = null
                }
            }
        },
        onPageChanged (page) {
            this.reports = [];
            this.fetchData(page)
            this.lastPage = page;
        },
        fetchData (page) {
            console.log("Richiesta report in scadenza")
            this.loading = true
            this.$api.reports.getScadenza({
                ...this.filters,
                p: page,
                n: this.rowsPerPage
            }).then(response => {
                this.loading = false

                var reportsTemp = [];

                reportsTemp = response.data.items
                this.totalItems = response.data.n

                if(reportsTemp)
                {
                    reportsTemp = reportsTemp.sort((a, b) => new Date(this.$utils.date.reverseDayMonth(a.dettagli.validita_attestato)) - new Date(this.$utils.date.reverseDayMonth(b.dettagli.validita_attestato)));

                    for(let i = 0; i < this.rowsPerPage; i++)
                    {
                        if(reportsTemp[i] != undefined)
                        {
                            this.reports.push(reportsTemp[i]);
                        }
                    }

                    this.reports.forEach(report => {
                        var timeMillis = new Date(this.$utils.date.reverseDayMonth(report.dettagli.validita_attestato));
                        var timeNowMillis = Date.now() + 2629800000;

                        // verifico se l'attestato è in scadenza
                        if(timeMillis.getTime() <= timeNowMillis)
                        {
                            console.log("Il report scade tra pocoo");
                            report.compilato = false; // utilizzo il flag compilato per segnalare se un attestato è in scadenza
                        }
                    });
                }
            }).catch(e => {
                console.log(e)
                this.$snackbar.showServerError(e)
                this.loading = false
            })
        }
    }
}
</script>
<style lang="scss" scoped>
  .date-input /deep/ .v-input__control {
    color: rgba(255, 255, 255, 0.7);
  }
</style>